import { Segment, SegmentGroup } from 'semantic-ui-react'
import { ScanditRadioLabelProps } from './types'

const ScanditRadioLabel = ({ id, image, title, description }: ScanditRadioLabelProps) => {
  return (
    <label htmlFor={id}>
      <SegmentGroup horizontal className="flex-center">
        <Segment className="flex-center" style={{ flex: '1 1 0%' }}>
          {image}
        </Segment>
        <Segment style={{ flex: '4 1 0%' }}>
          <div class="uppercase label-title">{title}</div>
          <div class="label-description">{description}</div>
        </Segment>
      </SegmentGroup>
    </label>
  )
}
export default ScanditRadioLabel
